"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzIcon = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
function SzIcon(_a) {
    var variant = _a.variant, icon = _a.icon, onClick = _a.onClick, className = _a.className;
    var iconClasses = classnames_1.default({
        'sz-icon-bold': variant === 'bold',
        'sz-icon-line': variant === 'line',
        'cursor-pointer': onClick
    }, icon, className);
    return (react_1.default.createElement("i", { className: iconClasses, onClick: onClick && (function (e) { return onClick(e, icon); }) }));
}
exports.SzIcon = SzIcon;
exports.default = SzIcon;
